import { BlogPostContent } from '@/types/blog';
import { introSection } from './sections/intro';
import { unbewusstGesteuertSection } from './sections/unbewusst-gesteuert';
import { mindsetVeraendernSection } from './sections/mindset-veraendern';
import { finanztagebuchSection } from './sections/finanztagebuch';
import { wartenRegelSection } from './sections/warten-regel';
import { glaubenssaetzeSection } from './sections/glaubenssaetze';
import { visualisierenSection } from './sections/visualisieren';
import { routinenSection } from './sections/routinen';
import { werteSection } from './sections/werte';
import { fazitSection } from './sections/fazit';
import { quellenSection } from './sections/quellen';

export const content: BlogPostContent = {
  sections: [
    introSection,
    unbewusstGesteuertSection,
    mindsetVeraendernSection,
    finanztagebuchSection,
    wartenRegelSection,
    glaubenssaetzeSection,
    visualisierenSection,
    routinenSection,
    werteSection,
    fazitSection,
    quellenSection
  ]
};
